// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1264":"f829fd78","1484":"e9c05e5d","2279":"fc749e97","4027":"4c99acb5","5617":"e9c05e5d","9487":"4c99acb5"}[chunkId] + ".chunk.css";
};